import { isObserverRole } from '@simsm/shared-types';

const CORE_HOME_PATH: Record<string, string> = {
  REGISTRAR_OPERATOR: '/operator/home',
  REGISTRAR_ADMIN: '/registrar-admin/home',
  SYSTEM_ADMIN: '/system-admin/home',
};

// Where a session lands once its active role is known. caiet UC61-03: every
// observer type lands on the same home, so the route is a predicate over the
// role name and not a per-institution entry.
//
// Three callers — the role picker (UC12), the development login, and the address
// MPass returns to (/login-success) — each of which used to carry its own copy
// of this map. The `/` fallback is unreachable: `activeRole` always holds a core
// role or an OBSERVER* code, and `isObserverRole` catches every one of those.
export function homePathFor(role: string): string {
  return isObserverRole(role) ? '/observer/home' : (CORE_HOME_PATH[role] ?? '/');
}

// Where a freshly minted session goes: the picker when the person holds more
// than one role (caiet UC12), otherwise straight to the home of the only one.
export function landingPathFor(activeRole: string, availableRoles: readonly string[]): string {
  return availableRoles.length > 1 ? '/role-select' : homePathFor(activeRole);
}
